import React, { FC, memo } from 'react'
import styled from 'styled-components'

import { Avatar } from '@ucheba/ui/components/Avatar/desktop'
import { useAvatar } from '@ucheba/utils/hooks/useAvatar'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'

import SC from '../base/InstitutionMembers.styles'
import { IInstitutionTeachersListItemProps } from '../types'

const Container = styled.div`
  display: flex;
  column-gap: 16px;
`

const { ListItem } = SC

const InstitutionTeachersListItem: FC<IInstitutionTeachersListItemProps> = (props) => {
  const {
    isDivider = true,
    fullName,
    description,
    avatarThumbnailUrl,
    fontSize = 'h3',
  } = props

  const avatarUrl = useAvatar(avatarThumbnailUrl)

  return (
    <ListItem isDivider={isDivider}>
      <Container>
        <Avatar imgUrl={avatarUrl} size='large' />

        <div>
          <Text fontWeight='bold' lineHeight={fontSize} fontSize={fontSize}>
            {fullName}
          </Text>

          <Spacing spacing='xxsmall' />

          {description && <Text firstLetterUppercase>{description}</Text>}
        </div>
      </Container>
    </ListItem>
  )
}

export default memo(InstitutionTeachersListItem)
